import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPriceFormat]'
})
export class PriceFormatDirective {
  maxValue: number = parseFloat('99999999999999999');

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const initialValue = this.el.nativeElement.value;
    const regex = new RegExp(/^\d{1,17}(\.\d{0,2})?$/);
    const match = regex.exec(initialValue);
    if (!match) {
      event.preventDefault();
      this.el.nativeElement.value = initialValue.substring(0, initialValue.length - 1);
    }
  }
}